import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';

@Component({
  standalone: true,
  imports: [CommonModule, HeaderBarComponent],
  selector: 'app-empty-dashboard',
  templateUrl: './empty-dashboard.component.html',
})
export class EmptyDashboardComponent {}
